import React from "react";
import { Box, Button } from "@mui/joy";
import { theme } from "../../styles/theme";
import useBottomSafePadding from "../../hooks/useBottomSafePadding";

export function BottomNextButton({
  disabled,
  onClick,
  text,
  background = theme.vars.palette.Background.Level1,
  highlightBackground,
  loading = false,
}: {
  disabled: boolean;
  onClick: () => void;
  text: string;
  background?: string;
  highlightBackground?: boolean;
  loading?: boolean;
}) {
  const pb = useBottomSafePadding("16px");

  return (
    <Box
      sx={{
        // 화면 하단에 고정
        position: "fixed",
        left: 0,
        bottom: 0,
        width: "100%",
        zIndex: 1200,
        background: !highlightBackground // TODO 리팩토링
          ? `linear-gradient(180deg, rgba(246, 249, 250, 0) 0%, ${background} 20%)`
          : `background: linear-gradient(180deg, rgba(220, 239, 250, 0) 0%, ${background} 20%)`,
        // background: linear-gradient(180deg, rgba(220, 239, 250, 0) 0%, #DCEFFA 20%);

        px: "20px",
        pt: 2,
        pb,
        display: "flex", // flexbox 사용
        justifyContent: "center", // 가로 가운데 정렬
      }}
    >
      <Button
        loading={loading}
        variant={"Action"}
        size={"lg"}
        sx={{
          maxWidth: "620px",
          width: "100%",
        }}
        disabled={disabled}
        onClick={onClick}
      >
        {text}
      </Button>
    </Box>
  );
}
